import { render, staticRenderFns } from "./present-opportunity-to-consumer.vue?vue&type=template&id=55334750&scoped=true"
import script from "./present-opportunity-to-consumer.vue?vue&type=script&lang=ts"
export * from "./present-opportunity-to-consumer.vue?vue&type=script&lang=ts"
import style0 from "./present-opportunity-to-consumer.vue?vue&type=style&index=0&id=55334750&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55334750",
  null
  
)

export default component.exports